export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angezeigt:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gesamt"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pro Seite"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anzeigen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ergebnisse"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["von"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handel"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handelsgeschäfte"])}
}